export const NOVU_ENCRYPTION_SUB_MASK = 'nvsk.';
/**
 * Public placeholder returned in API responses in place of secret values.
 * Used by both the API (when serializing secret variables) and the dashboard
 * (when rendering / detecting unchanged values in forms).
 */
export const SECRET_MASK = '••••••••';
//# sourceMappingURL=secrets.js.map